export function toTitleCase(str: string) {
    return str.replace(
        /([^\W_]+[^\s-]*) */g,
        function(word) {
            return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
        }
    );
}